import React, { SetStateAction, startTransition } from 'react';
import CustomButton from '../CustomButton';
import { ReactComponent as RealInfo } from 'assets/quote/realInfo.svg'
import { useNavigate } from 'react-router-dom';
import { IInfo, IQuote } from 'types/quote';
import { quoteInfoAtom } from 'atom/quote';
import { useSetAtom } from 'jotai';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    info: IInfo
}

const MainQuoteLoginPop = ({ isOpen, setIsOpen, info }: IConfrimDialog) => {
    const navigate = useNavigate();
    const setQuoteInfo = useSetAtom(quoteInfoAtom)

    const cancel = () => {
        setIsOpen(false);
    }

    const goDetail = (type: string) => {
        const newQuoteInfo: IQuote = {
            step1: {
                tradeType: info.originCode.includes('KR')
                    ? 'EXPORT'
                    : info.destinationCode.includes('KR')
                        ? 'IMPORT'
                        : 'EXPORT',
                transportType: info.transportType,
                originId: info.originId,
                originCode: info.originCode,
                originAddress: info.originAddress,
                destinationId: info.destinationId,
                destinationCode: info.destinationCode,
                destinationAddress: info.destinationAddress,
            },
            step2: {
                shipmentMode: info.shipmentMode?.includes('FCL') ? 'FCL-DRY' : 'LCL',
            },
            amount: String(info.amount),
        } as IQuote;

        setQuoteInfo(newQuoteInfo);
        window.sessionStorage.setItem(type, JSON.stringify(newQuoteInfo));
        window.sessionStorage.setItem('type', 'main');

        startTransition(() => {
            navigate(`/quote/${type}/create`);
        });
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className="flex justify-center items-center">
                            <RealInfo />
                        </div>
                        <div className='flex flex-col gap-3'>
                            <p className='text-2xl'>추가 정보가 필요합니다.</p>
                            <div>
                                <p className='text-[#9D9EB7]'>작성하신 정보는 하단의 <span className='font-semibold text-primary'>간편견적</span> 및 <span className='font-semibold text-primary'>상세견적</span> 작성 시 자동으로 동기화됩니다.</p>
                                <p className='text-[#9D9EB7]'>보다 상세한 견적을 원하신다면 간편견적 또는 일반견적을 통해 진행해주세요.</p>
                            </div>
                        </div>

                        <div className="flex justify-center gap-4">
                            <CustomButton title={'닫기'} onClick={cancel} className='hover:!bg-white !border-[#9D9EB7] w-[200px] !h-15 !text-[#9D9EB7]' />
                            <CustomButton
                                title={'간편견적 바로가기'}
                                onClick={() => { goDetail('simple') }}
                                className={'w-[200px] !h-15 bg-primary'}
                            />
                            <CustomButton
                                title={'상세견적 바로가기'}
                                onClick={() => { goDetail('normal') }}
                                className={'w-[200px] !h-15 bg-primary'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainQuoteLoginPop;